/**
 * Settings API (WP31 / Spec §K).
 */

import {
  publicSettingsSchema,
  researchKillSwitchSettingSchema,
  type PublicSettings,
  type ResearchKillSwitchSetting,
} from "@carago/shared";
import { apiFetch, type ApiFetchOptions } from "./api.js";

export async function getPublicSettings(
  options?: ApiFetchOptions,
): Promise<PublicSettings> {
  const raw = await apiFetch<unknown>("/v1/settings/public", {
    method: "GET",
    ...options,
  });
  return publicSettingsSchema.parse(raw);
}

export async function setResearchKillSwitch(
  enabled: boolean,
  options?: ApiFetchOptions,
): Promise<ResearchKillSwitchSetting> {
  const body = researchKillSwitchSettingSchema.parse({ enabled });
  const raw = await apiFetch<unknown>("/v1/settings/research-kill-switch", {
    method: "PUT",
    body,
    ...options,
  });
  return researchKillSwitchSettingSchema.parse(raw);
}
